<template>
  <el-tabs class="tab-button" v-model="activeTab">
    <el-tab-pane label="임계치 가이드 설정" name="WGuideSettingView">
      <w-guide-setting-view ref="WGuideSettingView" :active-tab="activeTab"/>
    </el-tab-pane>
    <el-tab-pane label="임계치 가이드 결과" name="WGuideResultView">
      <w-guide-result-view ref="WGuideResultView" :active-tab="activeTab"/>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import WGuideSettingView from './GuideSetting/GuideSettingView';
import WGuideResultView from './GuideSetting/GuideResultView';
import WPredictTargetObjTree from '@/views/settings/operation/BasicInfoSettings/EventPredictSetting/components/PredictTargetObjTree';
/**
 * 임계치 가이드 설정 화면
 */
export default {
  name: 'WEventPredictGuideView',
  components: {
    WGuideSettingView,
    WGuideResultView,
    WPredictTargetObjTree,
  },
  watch: {
    activeTab() {
      this.activeTabLoad();
    },
  },
  data() {
    return {
      activeTab: 'WGuideSettingView',
    };
  },
  methods: {
    loadData() {
      this.activeTabLoad();
    },
    activeTabLoad() {
      this.$nextTick(() => {
        const activeTab = this.activeTab;
        this.$refs[activeTab].loadData();
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/EventPredictSetting/EventPredictGuideView.vue